export const playerDesignKeys = {
  all: () => ['PLAYER_DESIGN'] as const,
};
